"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appendElement = void 0;

var _checkSpecialCharsAndEmpty = require("./check-special-chars-and-empty");

var separatorOrLineBreak = function separatorOrLineBreak(length, elementIdx, separator) {
  return length - 1 === elementIdx ? '\n' : separator;
};

var escapeDoubleQuotesInsideElement = function escapeDoubleQuotesInsideElement(element) {
  return element.replace(/"/g, '""');
};

var appendElement = function appendElement(element, lineLength, elementIdx, separator) {
  var includesSpecials = (0, _checkSpecialCharsAndEmpty.checkSpecialCharsAndEmpty)(element);
  var thisElement = element;

  if (includesSpecials) {
    thisElement = escapeDoubleQuotesInsideElement(thisElement);
  }

  return includesSpecials ? "\"".concat(thisElement, "\"").concat(separatorOrLineBreak(lineLength, elementIdx, separator)) : "".concat(thisElement).concat(separatorOrLineBreak(lineLength, elementIdx, separator));
};

exports.appendElement = appendElement;